import InlineComponent from './inlineComponent.jsx';

import React from 'react';
import JsonPreview from '../../../components/JsonPreview.jsx';
import useToggle from '../../../components/hooks/useToggle.jsx';

export default function FirewallPolicyPreview(props) {
  const modalToggle = useToggle(false);

  return (
    <span>
      <a
        className='ui button'
        onClick={modalToggle.toggle}
      >
        <i className='unhide outline icon'></i>
        JSON
      </a>

      <JsonPreview
        hosts={props.hosts}
        link={props.valueLink}
        name={props.templateName}
        open={modalToggle.value}
        renderedEntity={'firewall policy'}
        title={props.title}
        onClose={modalToggle.toggle}
      />
    </span>
  );
}

module.exports = class OutputRenderer extends InlineComponent {
  define() {
    this.component = FirewallPolicyPreview;
  }
};
